module.exports = __webpack_public_path__ + "static/ic-miq-e42facf7dad4e749713dbaa01864dc3a.png";